export enum SubmissionStatus {
    SUBMITTED = 'SUBMITTED',
    GRADED = 'GRADED',
    RETURNED = 'RETURNED',
    LATE = 'LATE',
    MISSING = 'MISSING',
}

export interface SubmissionRequirementResponse {
    activityId: number;
    activityName: string;
    requiresSubmission: boolean;
    isImportant: boolean;
    mandatoryForFacultyStudents: boolean;    scoreType?: string;
}

export interface SubmissionAttachment {
    url: string;
    type: "file" | "image";
}

export interface TaskSubmissionResponse {
    id: number;
    // Task
    taskId: number;
    taskTitle: string;
    // Student
    studentId: number;
    studentCode: string;
    studentName: string;
    // Content & files
    content: string | null;
    fileUrls: string[];
    attachments: SubmissionAttachment[];
    // Grading
    score: number | null;
    isCompleted: boolean | null;
    feedback: string | null;
    graderId: number | null;
    graderUsername: string | null;
    // Status & timestamps
    status: SubmissionStatus;
    submittedAt: string; // ISO string from LocalDateTime
    updatedAt: string; // ISO string from LocalDateTime
    gradedAt: string | null; // ISO string from LocalDateTime
}

export interface CreateSubmissionRequest {
    content?: string;
    files?: File[];
    images?: File[];
}

export interface UpdateSubmissionRequest {
    content?: string;
    files?: File[];
    images?: File[];
}
